import { BodyText } from 'styling/Typography'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { IFoodHistoryDay } from 'types/foodLogistics/foodHistory.interface'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

const historyColumns: IHonestTableColumn<IFoodHistoryDay>[] = [
  {
    id: 'date',
    header: 'Date',
    sticky: true,
    minWidth: '8rem',
    cell: (r) => <BodyText weight='600'>{r.date}</BodyText>,
  },
  {
    id: 'status',
    header: 'Status',
    cell: (r) => (
      <StatusPill status={r.status === 'Finalized' ? 'success' : 'info'}>{r.status}</StatusPill>
    ),
  },
  { id: 'breakfast', header: 'Breakfast', cell: (r) => <BodyText>{r.breakfast}</BodyText> },
  { id: 'lunch', header: 'Lunch', cell: (r) => <BodyText>{r.lunch}</BodyText> },
  { id: 'dinner', header: 'Dinner', cell: (r) => <BodyText>{r.dinner}</BodyText> },
  { id: 'nightMeal', header: 'Night Meal', cell: (r) => <BodyText>{r.nightMeal}</BodyText> },
  { id: 'exceptions', header: 'Exceptions', cell: (r) => <BodyText>{r.exceptions}</BodyText> },
  { id: 'standbyUsed', header: 'Standby Used', cell: (r) => <BodyText>{r.standbyUsed}</BodyText> },
  {
    id: 'reversals',
    header: 'Reversals',
    cell: (r) =>
      r.reversals > 0 ? (
        <StatusPill status='accent'>{`${r.reversals} reversal`}</StatusPill>
      ) : (
        <BodyText>—</BodyText>
      ),
  },
  {
    id: 'drill',
    header: '',
    align: 'right',
    cell: () => <BodyText>—</BodyText>,
  },
]

export const HistoryTab = () => {
  const { provisioningRecords } = useSelector((store: RootState) => store.food)

  const data: IFoodHistoryDay[] = (provisioningRecords.data || []).map((item, index) => {
    const breakfast = item.mealTypes.find((x) => x.mealType.name.toLowerCase().includes('breakfast'))?.totalCount || 0
    const lunch = item.mealTypes.find((x) => x.mealType.name.toLowerCase().includes('lunch'))?.totalCount || 0
    const dinner = item.mealTypes.find((x) => x.mealType.name.toLowerCase().includes('dinner'))?.totalCount || 0
    const nightMeal = item.mealTypes.find((x) => x.mealType.name.toLowerCase().includes('night'))?.totalCount || 0
    const total = item.mealTypes.reduce((sum, x) => sum + x.totalCount, 0)
    return {
      id: `${item.foodSupplier.id}-${index}`,
      date: item.foodSupplier.name,
      status: 'In Progress',
      breakfast: String(breakfast),
      lunch: String(lunch),
      dinner: String(dinner),
      nightMeal: String(nightMeal),
      exceptions: 0,
      standbyUsed: 0,
      reversals: total > 0 ? 0 : 0,
    }
  })

  return <HonestTable columns={historyColumns} data={data} keyField='id' />
}
